module.exports = __webpack_public_path__ + "static/img/18.481f620.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/18.png
// module id = o/+u
// module chunks = 0